export default __webpack_public_path__ + "static/media/flayer88.57f2ecd8.jpg";